// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrattendancepg-inline-1 {
  display: flex;
  gap: 8px;
  align-items: center;
}

.hrattendancepg-inline-2 {
  display: grid;
  grid-template-columns: repeat(5,1fr);
  gap: 10px;
  padding: 12px 16px;
}

.hrattendancepg-inline-3 {
  padding: 0;
  overflow-x: auto;
}

.hrattendancepg-inline-4 {
  font-family: monospace;
  font-size: 11px;
}

.hrattendancepg-inline-5 {
  font-weight: 600;
}

.hrattendancepg-inline-6 {
  font-size: 11px;
}

.hrattendancepg-inline-7 {
  font-size: 11px;
}

.hrattendancepg-inline-8 {
  font-size: 11px;
}

.hrattendancepg-inline-9 {
  font-size: 11px;
}

.hrattendancepg-inline-10 {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.hrattendancepg-inline-11 {
  max-width: 220px;
  margin-bottom: 0;
}

.hrattendancepg-inline-12 {
  max-width: 180px;
  margin-bottom: 0;
}

.hrattendancepg-inline-13 {
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 8px;
}

.hrattendancepg-inline-14 {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow-x: auto;
}

.hrattendancepg-inline-15 {
  margin-bottom: 0;
}

.hrattendancepg-inline-16 {
  font-weight: 600;
}

.hrattendancepg-inline-17 {
  font-size: 11px;
}

.hrattendancepg-inline-18 {
  display: flex;
  align-items: center;
  gap: 10px;
}

.hrattendancepg-inline-19 {
  font-size: 13px;
  font-weight: 600;
}

.hrattendancepg-inline-20 {
  font-size: 13px;
  font-weight: 600;
}

.hrattendancepg-inline-21 {
  font-size: 13px;
  font-weight: 600;
}

.hrattendancepg-inline-22 {
  font-size: 13px;
  font-weight: 600;
}

.hrattendancepg-inline-23 {
  font-size: 13px;
  font-weight: 600;
}

.hrattendancepg-inline-24 {
  color: #2563eb;
  font-weight: 600;
}

.hrattendancepg-inline-25 {
  padding: 0;
  overflow-x: auto;
}

.hrattendancepg-inline-26 {
  font-weight: 600;
}

.hrattendancepg-inline-27 {
  font-size: 11px;
}

.hrattendancepg-inline-28 {
  font-size: 11px;
}

.hrattendancepg-inline-29 {
  font-size: 11px;
}

.hrattendancepg-inline-30 {
  font-size: 11px;
}

.hrattendancepg-inline-31 {
  font-size: 11px;
}

.hrattendancepg-inline-32 {
  display: flex;
  gap: 4px;
}

.hrattendancepg-dyn-1 {
  padding: 4px 8px;
  border-radius: 6px;
  border: var(--hrattendancepg-1-border);
  font-size: 12px;
}

.hrattendancepg-dyn-2 {
  padding: 4px 8px;
  border-radius: 6px;
  border: var(--hrattendancepg-2-border);
  font-size: 12px;
}

.hrattendancepg-dyn-3 {
  background: var(--hrattendancepg-3-background);
  border: var(--hrattendancepg-3-border);
  border-radius: 10px;
  padding: 10px 14px;
  text-align: center;
}

.hrattendancepg-dyn-4 {
  font-size: 11px;
  color: var(--hrattendancepg-4-color);
  font-weight: 600;
}

.hrattendancepg-dyn-5 {
  text-align: center;
  padding: 30px;
  color: var(--hrattendancepg-5-color);
}

.hrattendancepg-dyn-6 {
  text-align: center;
  padding: 30px;
  color: var(--hrattendancepg-6-color);
}

.hrattendancepg-dyn-7 {
  text-align: center;
  padding: 20px;
  color: var(--hrattendancepg-7-color);
}

.hrattendancepg-dyn-8 {
  text-align: center;
  padding: 20px;
  color: var(--hrattendancepg-8-color);
}

.hrattendancepg-dyn-9 {
  text-align: center;
  padding: 20px;
  color: var(--hrattendancepg-9-color);
  font-size: 12px;
}

.hrattendancepg-dyn-10 {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background: var(--hrattendancepg-10-background);
}

.hrattendancepg-dyn-11 {
  font-size: 11px;
  color: var(--hrattendancepg-11-color);
}

.hrattendancepg-dyn-12 {
  font-size: 11px;
  color: var(--hrattendancepg-12-color);
}

.hrattendancepg-dyn-13 {
  font-size: 14px;
  font-weight: 700;
  color: var(--hrattendancepg-13-color);
}

.hrattendancepg-dyn-14 {
  font-size: 11px;
  color: var(--hrattendancepg-14-color);
}

.hrattendancepg-dyn-15 {
  font-size: 14px;
  font-weight: 700;
  color: var(--hrattendancepg-15-color);
}

.hrattendancepg-dyn-16 {
  font-size: 11px;
  color: var(--hrattendancepg-16-color);
}

.hrattendancepg-dyn-17 {
  font-size: 14px;
  font-weight: 700;
  color: var(--hrattendancepg-17-color);
}

.hrattendancepg-dyn-18 {
  font-size: 11px;
  color: var(--hrattendancepg-18-color);
}

.hrattendancepg-dyn-19 {
  text-align: center;
  padding: 30px;
  color: var(--hrattendancepg-19-color);
}

.hrattendancepg-dyn-20 {
  font-size: 10px;
  color: var(--hrattendancepg-20-color);
}

.hrattendancepg-dyn-value {
  font-size: 22px;
  font-weight: 800;
  color: var(--hrattendancepg-value-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrAttendancePg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C","sourcesContent":[".hrattendancepg-inline-1 {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.hrattendancepg-inline-2 {\n  display: grid;\n  grid-template-columns: repeat(5,1fr);\n  gap: 10px;\n  padding: 12px 16px;\n}\n\n.hrattendancepg-inline-3 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.hrattendancepg-inline-4 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-5 {\n  font-weight: 600;\n}\n\n.hrattendancepg-inline-6 {\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-7 {\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-8 {\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-9 {\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-10 {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n}\n\n.hrattendancepg-inline-11 {\n  max-width: 220px;\n  margin-bottom: 0;\n}\n\n.hrattendancepg-inline-12 {\n  max-width: 180px;\n  margin-bottom: 0;\n}\n\n.hrattendancepg-inline-13 {\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.hrattendancepg-inline-14 {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow-x: auto;\n}\n\n.hrattendancepg-inline-15 {\n  margin-bottom: 0;\n}\n\n.hrattendancepg-inline-16 {\n  font-weight: 600;\n}\n\n.hrattendancepg-inline-17 {\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-18 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.hrattendancepg-inline-19 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.hrattendancepg-inline-20 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.hrattendancepg-inline-21 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.hrattendancepg-inline-22 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.hrattendancepg-inline-23 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.hrattendancepg-inline-24 {\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.hrattendancepg-inline-25 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.hrattendancepg-inline-26 {\n  font-weight: 600;\n}\n\n.hrattendancepg-inline-27 {\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-28 {\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-29 {\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-30 {\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-31 {\n  font-size: 11px;\n}\n\n.hrattendancepg-inline-32 {\n  display: flex;\n  gap: 4px;\n}\n\n.hrattendancepg-dyn-1 {\n  padding: 4px 8px;\n  border-radius: 6px;\n  border: var(--hrattendancepg-1-border);\n  font-size: 12px;\n}\n\n.hrattendancepg-dyn-2 {\n  padding: 4px 8px;\n  border-radius: 6px;\n  border: var(--hrattendancepg-2-border);\n  font-size: 12px;\n}\n\n.hrattendancepg-dyn-3 {\n  background: var(--hrattendancepg-3-background);\n  border: var(--hrattendancepg-3-border);\n  border-radius: 10px;\n  padding: 10px 14px;\n  text-align: center;\n}\n\n.hrattendancepg-dyn-4 {\n  font-size: 11px;\n  color: var(--hrattendancepg-4-color);\n  font-weight: 600;\n}\n\n.hrattendancepg-dyn-5 {\n  text-align: center;\n  padding: 30px;\n  color: var(--hrattendancepg-5-color);\n}\n\n.hrattendancepg-dyn-6 {\n  text-align: center;\n  padding: 30px;\n  color: var(--hrattendancepg-6-color);\n}\n\n.hrattendancepg-dyn-7 {\n  text-align: center;\n  padding: 20px;\n  color: var(--hrattendancepg-7-color);\n}\n\n.hrattendancepg-dyn-8 {\n  text-align: center;\n  padding: 20px;\n  color: var(--hrattendancepg-8-color);\n}\n\n.hrattendancepg-dyn-9 {\n  text-align: center;\n  padding: 20px;\n  color: var(--hrattendancepg-9-color);\n  font-size: 12px;\n}\n\n.hrattendancepg-dyn-10 {\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n  background: var(--hrattendancepg-10-background);\n}\n\n.hrattendancepg-dyn-11 {\n  font-size: 11px;\n  color: var(--hrattendancepg-11-color);\n}\n\n.hrattendancepg-dyn-12 {\n  font-size: 11px;\n  color: var(--hrattendancepg-12-color);\n}\n\n.hrattendancepg-dyn-13 {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--hrattendancepg-13-color);\n}\n\n.hrattendancepg-dyn-14 {\n  font-size: 11px;\n  color: var(--hrattendancepg-14-color);\n}\n\n.hrattendancepg-dyn-15 {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--hrattendancepg-15-color);\n}\n\n.hrattendancepg-dyn-16 {\n  font-size: 11px;\n  color: var(--hrattendancepg-16-color);\n}\n\n.hrattendancepg-dyn-17 {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--hrattendancepg-17-color);\n}\n\n.hrattendancepg-dyn-18 {\n  font-size: 11px;\n  color: var(--hrattendancepg-18-color);\n}\n\n.hrattendancepg-dyn-19 {\n  text-align: center;\n  padding: 30px;\n  color: var(--hrattendancepg-19-color);\n}\n\n.hrattendancepg-dyn-20 {\n  font-size: 10px;\n  color: var(--hrattendancepg-20-color);\n}\n\n.hrattendancepg-dyn-value {\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--hrattendancepg-value-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
